import { Icon } from '@chakra-ui/react';

const PCTextDividerIcon = (props) => (
    <Icon
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 30 30"
        fill={'#4A5668'}
        // style="enable-background:new 0 0 1500 1500;"
        {...props}>

        <g>
            <path class="st0" d="M15.33,14.79c0.76,0.07,0.94,0.17,0.95,0.5c0,0.34-0.21,0.46-0.95,0.51c0,0.86,0,1.73,0,2.62
		c0.07-0.05,0.13-0.09,0.19-0.13c0.21-0.13,0.47-0.1,0.62,0.09c0.16,0.19,0.19,0.42,0.03,0.6c-0.34,0.37-0.69,0.73-1.06,1.07
		c-0.19,0.17-0.46,0.13-0.66-0.07c-0.3-0.29-0.58-0.58-0.87-0.87c-0.24-0.24-0.26-0.52-0.07-0.73c0.19-0.2,0.44-0.21,0.71-0.01
		c0.03,0.02,0.05,0.04,0.11,0.08c0-0.9,0-1.76,0-2.63c-0.4-0.04-0.94,0.1-0.94-0.51c0.01-0.59,0.54-0.46,0.93-0.49
		c0-0.87,0-1.74,0-2.63c-0.08,0.06-0.14,0.11-0.21,0.14c-0.22,0.12-0.43,0.1-0.6-0.09c-0.17-0.18-0.2-0.42-0.04-0.6
		c0.34-0.38,0.71-0.74,1.08-1.09c0.18-0.16,0.44-0.12,0.64,0.07c0.31,0.3,0.61,0.6,0.91,0.91c0.21,0.22,0.22,0.49,0.05,0.69
		c-0.18,0.21-0.44,0.22-0.71,0.03c-0.03-0.02-0.06-0.04-0.11-0.08C15.33,13.06,15.33,13.91,15.33,14.79z"/>
            <path class="st0" d="M3.18,15.79c-0.31,0-0.62,0.01-0.93,0c-0.31-0.01-0.51-0.21-0.51-0.49c0-0.28,0.2-0.48,0.52-0.49
		c0.62-0.01,1.24-0.01,1.86,0c0.31,0,0.52,0.2,0.53,0.48c0.01,0.28-0.22,0.49-0.54,0.5C3.8,15.8,3.49,15.79,3.18,15.79z"/>
            <path class="st0" d="M7.04,15.79c-0.3,0-0.6,0-0.9,0c-0.32-0.01-0.54-0.22-0.53-0.5c0.01-0.27,0.22-0.47,0.53-0.48
		c0.62-0.01,1.24-0.01,1.86,0c0.31,0,0.51,0.2,0.51,0.49c0,0.28-0.2,0.48-0.51,0.49C7.68,15.8,7.36,15.79,7.04,15.79z"/>
            <path class="st0" d="M10.92,15.79c-0.3,0-0.6,0-0.9,0c-0.33-0.01-0.53-0.21-0.53-0.5c0.01-0.28,0.21-0.47,0.52-0.48
		c0.62,0,1.24-0.01,1.86,0c0.3,0,0.52,0.21,0.52,0.49c0,0.28-0.21,0.48-0.52,0.49C11.56,15.8,11.24,15.79,10.92,15.79z"/>
            <path class="st0" d="M18.66,15.79c-0.3,0-0.6,0.01-0.9,0c-0.31-0.01-0.52-0.21-0.52-0.49c0-0.27,0.21-0.49,0.51-0.49
		c0.63-0.01,1.26-0.01,1.89,0c0.31,0,0.5,0.21,0.5,0.5c-0.01,0.27-0.2,0.47-0.49,0.48C19.32,15.8,18.99,15.79,18.66,15.79z"/>
            <path class="st0" d="M29.06,5.25c-0.22,0.26-0.54,0.31-0.92,0.31c-8.88-0.01-17.76,0-26.64-0.01c-0.13,0-0.27,0.01-0.4-0.01
		C0.78,5.48,0.59,5.32,0.59,5.06c0-0.26,0.19-0.42,0.51-0.48c0.13-0.02,0.26-0.01,0.4-0.01c8.88,0,17.76,0,26.64-0.01
		c0.39,0,0.7,0.06,0.92,0.31C29.06,5,29.06,5.12,29.06,5.25z"/>
            <path class="st0" d="M29.06,9.54c-0.22,0.26-0.54,0.31-0.92,0.31c-8.88-0.01-17.76,0-26.64-0.01c-0.13,0-0.27,0.01-0.4-0.01
		C0.78,9.77,0.59,9.61,0.59,9.35c0-0.26,0.19-0.42,0.51-0.48c0.13-0.02,0.26-0.01,0.4-0.01c8.88,0,17.76,0,26.64-0.01
		c0.39,0,0.7,0.06,0.92,0.31C29.06,9.29,29.06,9.41,29.06,9.54z"/>
            <path class="st0" d="M29.06,1.61c-0.22,0.26-0.54,0.31-0.92,0.31c-8.88-0.01-17.76,0-26.64-0.01c-0.13,0-0.27,0.01-0.4-0.01
		C0.78,1.85,0.59,1.69,0.59,1.43c0-0.26,0.19-0.42,0.51-0.48c0.13-0.02,0.26-0.01,0.4-0.01c8.88,0,17.76,0,26.64-0.01
		c0.39,0,0.7,0.06,0.92,0.31C29.06,1.37,29.06,1.49,29.06,1.61z"/>
            <path class="st0" d="M29.06,28.69C28.84,28.94,28.52,29,28.14,29c-8.88-0.01-17.76,0-26.64-0.01c-0.13,0-0.27,0.01-0.4-0.01
		c-0.32-0.06-0.51-0.22-0.51-0.48c0-0.26,0.19-0.42,0.51-0.48C1.22,27.99,1.36,28,1.49,28c8.88,0,17.76,0,26.64-0.01
		c0.39,0,0.7,0.06,0.92,0.31C29.06,28.44,29.06,28.56,29.06,28.69z"/>
            <path class="st0" d="M29.06,25.05c-0.22,0.26-0.54,0.31-0.92,0.31c-8.88-0.01-17.76,0-26.64-0.01c-0.13,0-0.27,0.01-0.4-0.01
		c-0.32-0.06-0.51-0.22-0.51-0.48c0-0.26,0.19-0.42,0.51-0.48c0.13-0.02,0.26-0.01,0.4-0.01c8.88,0,17.76,0,26.64-0.01
		c0.39,0,0.7,0.06,0.92,0.31C29.06,24.81,29.06,24.93,29.06,25.05z"/>
            <path class="st0" d="M29.06,21.43c-0.22,0.26-0.54,0.31-0.92,0.31c-8.88-0.01-17.76,0-26.64-0.01c-0.13,0-0.27,0.01-0.4-0.01
		c-0.32-0.06-0.51-0.22-0.51-0.48c0-0.26,0.19-0.42,0.51-0.48c0.13-0.02,0.26-0.01,0.4-0.01c8.88,0,17.76,0,26.64-0.01
		c0.39,0,0.7,0.06,0.92,0.31C29.06,21.19,29.06,21.31,29.06,21.43z"/>
        </g>

    </Icon>
);

export default PCTextDividerIcon;
